import { EditorItem } from '../../store/editorStore';

type AutoImageItemContentProps = {
  item: EditorItem;
};

export function AutoImageItemContent({ item }: AutoImageItemContentProps) {
  const style = item.style as any;
  
  // Xử lý hiển thị viền ô chứa
  const borderStyle = style.borderWidth && style.borderWidth > 0
    ? `${style.borderWidth}px solid ${style.borderColor || '#000'}`
    : 'none';

  // Lấy loại auto-image để hiển thị phù hợp
  const isSearchType = item.type === 'auto-image';
  const label = isSearchType ? 'Từ khóa' : 'Prompt';
  const description = isSearchType 
    ? 'Ảnh sẽ tự động tìm kiếm từ từ khóa' 
    : 'Ảnh sẽ sinh từ khóa tìm kiếm từ prompt';
  
  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(200, 200, 200, 0.2)',
      fontSize: '12px',
      overflow: 'hidden',
      border: borderStyle
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ 
          padding: '6px', 
          backgroundColor: isSearchType ? '#f0f0f0' : '#eef5ff',
          borderRadius: '4px',
          color: isSearchType ? '#333' : '#0c59b9',
          border: `1px solid ${isSearchType ? '#ddd' : '#cce0ff'}`,
          fontSize: '11px',
          fontWeight: 'bold'
        }}>
          {label}: {item.content || (isSearchType ? 'Chưa có từ khóa' : 'Chưa có prompt')}
        </span>
      </div>
      <div style={{ marginTop: '6px', color: '#777', textAlign: 'center', padding: '0 5px' }}>
        {description}
      </div>
    </div>
  );
} 